import React, { FC, useState } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { useTranslation } from 'app/lang';
import LiveStream from 'app/modules/LiveStream';
import MatchesDropdown from 'app/modules/LiveStream/components/MatchesDropdown';
import ToolbarControls from 'app/modules/LiveStream/components/ToolbarControls';
import { selectLiveStreamLoading, streamsByLiveMatchesSelector } from 'app/modules/LiveStream/selectors';

import dictionary from './LiveStream.dictionary.json';

import styles from './SidebarLiveStream.module.scss';

// ---

type StoreProps = {
  hasLiveStream: boolean;
  loading: boolean;
};

const SidebarLiveStream: FC<StoreProps> = ({
  hasLiveStream,
  loading,
}) => {
  const [videoContainer, setVideoContainer] = useState<HTMLDivElement | null>(null);
  const { t } = useTranslation();

  const callbackRef = (elem: HTMLDivElement | null) => {
    if (elem !== null) {
      setVideoContainer(elem);
    }
  };

  const dropdownContent = () => {
    return hasLiveStream
      ? (
        <MatchesDropdown />
      )
      : (
        <span className={styles.notFound}>
          {t(dictionary.notFound)}
        </span>
      );
  };

  return (
    <div ref={callbackRef}
         id="videoContainer"
         data-test="translation-video-container">
      <header className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>
            {t(dictionary.title)}
          </h1>

          <div className={styles.actions}>
            {hasLiveStream && (
              <ToolbarControls videoContainer={videoContainer} />
            )}
          </div>
        </div>
        {!loading && dropdownContent()}
      </header>

      {hasLiveStream && (
        <LiveStream />
      )}
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  hasLiveStream: streamsByLiveMatchesSelector(state).size > 0,
  loading: selectLiveStreamLoading(state),
});

export default connect(mapStateToProps)(SidebarLiveStream);
